export default [{
  price: 60,
  month: 1,
  ya: 100,
  now: true
}, {
  price: 150,
  month: 3,
  ya: 300
}, {
  price: 220,
  month: 6,
  ya: 100
}, {
  price: 300,
  month: 1,
  ya: 100
}, {
  price: 300,
  month: 1
}, {
  price: 60,
  month: 1,
  ya: 100
}, {
  price: 60,
  month: 1,
  hidden_info: true
}, {
  price: 300,
  month: 1,
  ya: 100
}]
